import { createApi } from "@reduxjs/toolkit/query/react";
import { HEADER, HttpMethod, TagId, TagType } from "../../data/constants";
import { createBaseQuery } from "../helpers/baseQueryHelper";
import { Header } from "../../data/interfaces";

const headerApi = createApi({
  reducerPath: HEADER.reducerPath,
  baseQuery: createBaseQuery(HEADER.baseUrl),
  tagTypes: HEADER.tagTypes,
  endpoints(builder) {
    return {
      getMyHeaders: builder.query<Header[], void>({
        query: () => ({
          url: "/my-headers",
          method: HttpMethod.GET,
        }),
        providesTags: () => [{ type: TagType.Header, id: TagId.LIST }],
      }),
      updateHeader: builder.mutation<Header, Partial<Header> & { _id: string }>(
        {
          query: ({ _id, ...body }) => ({
            url: `/${_id}`,
            method: HttpMethod.PUT,
            body,
          }),
          invalidatesTags: [{ type: TagType.Header, id: TagId.LIST }],
        }
      ),
      toggleHeaderActive: builder.mutation<
        void,
        { headerId: string; isActive: boolean }
      >({
        query: ({ headerId, isActive }) => ({
          url: `/${headerId}/active`,
          method: HttpMethod.PATCH,
          params: { isActive },
        }),
        invalidatesTags: [{ type: TagType.Header, id: TagId.LIST }],
      }),
    };
  },
});

export const {
  useGetMyHeadersQuery,
  useUpdateHeaderMutation,
  useToggleHeaderActiveMutation,
} = headerApi;

export { headerApi };
